import { Markdown } from '@cadstrom/sigma-engine-shared';

import { BasicRemarkPlugin } from './markdown-plugins-utils.js';
import { SeverityMarkdownItem } from './severity-reference-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/**
 * Remark plugin definition for severity reference directives (`:severity[pass]`).
 * Display-only: no shorthand marker and no editor plugin.
 */
export const severityMarkdownItemDefinition: RemarkMarkdownDirectiveDefinition<
	typeof Markdown.SeverityMarkdownDirectiveDefinition
> = {
	allowedAttributes: Markdown.SeverityMarkdownDirectiveDefinition.allowedAttributes,
	directive: BasicRemarkPlugin(
		Markdown.SeverityMarkdownDirectiveDefinition.directive,
		Markdown.NodeTypes.AllDirectives,
		{ contentPropName: Markdown.SeverityMarkdownDirectiveDefinition.contentAttributeName },
	),
	item: SeverityMarkdownItem,
};
